export default __webpack_public_path__ + "static/media/One_Hundred_bp_DNA_Ladder_M.29df68b1.svg";